import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const privateRoute = true;
const restricted = true;
const components = [
  { name: "Login", path: "/login", restricted },
  { name: "Signup", path: "/signup", restricted },
  { name: "Home", path: "/" },
  { name: "Levels", path: "/levels/:id", privateRoute },
  { name: "Stats", path: "/stats", privateRoute },
  { name: "Dashboard", path: "/dashboard", privateRoute },
  { name: "Dashboard/Users", path: "/dashboard/users" },
  { name: "Leaderboard", path: "/leaderboard" },
];

const PrivateRoutes = ({ component: Comp, restricted = false, ...rest }) => {
  const { isAuth, activeUser } = useAuth();
  console.log(restricted);
  return (
    <Route
      {...rest}
      component={(props) =>
        isAuth ? (
          restricted && activeUser.role !== "admin" ? (
            <Redirect to="/stats" />
          ) : (
            <Comp {...props} />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

const PublicRoutes = ({ component: Comp, restricted = false, ...rest }) => {
  const { isAuth } = useAuth();
  return (
    <Route
      {...rest}
      component={(props) =>
        restricted ? (
          isAuth ? (
            <Redirect to="/stats" />
          ) : (
            <Comp {...props} />
          )
        ) : (
          <Comp {...props} />
        )
      }
    />
  );
};

const Routes = () => {
  return (
    <Switch>
      {components.map(({ name, nested, privateRoute = false, ...rest }, i) => {
        const Route = privateRoute ? PrivateRoutes : PublicRoutes;
        const component = require(`../components/${name}`)[nested || "default"];
        return <Route key={i} {...rest} exact component={component} />;
      })}
    </Switch>
  );
};

export default Routes;
